import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SearchSkeleton","Search"] */ "/vercel/path0/src/app/(main-layout)/blog/(page-layout)/components/search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoButton"] */ "/vercel/path0/src/components/video-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/blog-fallback.png");
